(function () {
  // Map by PRODUCT HANDLE (the part after /products/)
  const TOAST_BY_HANDLE = {
    "medium-roast-arabica": "✨Great choice. You like your coffee aromatic!",
    "arabica-dark-roast": "🌞 Your mornings just improved!",
    "robusta-medium-roast": "👌That’s a premium pick!",
    "dark-roast-robusta": " 💯 Your brew game is strong!",
    "strong-coffee-blend": "🐘 Unlock your mornings. Smart pick!",
    "bold-coffee-blend": "🐵 Mug-nificent choice!",
    "arabica-robusta-blend-coffee": "🦒 Pure coffee bliss, added now"
  };

  // ===== Mobile drawer auto-close settings =====
  const MOBILE_MAX_WIDTH = 749;      // Dawn breakpoint
  const DRAWER_AUTO_CLOSE_MS = 3000; // close after 3s on mobile

  const originalFetch = window.fetch;
  if (!originalFetch) return;

  if (window.__stockup_toast_fetch_patched) return;
  window.__stockup_toast_fetch_patched = true;

  let drawerCloseTimer = null;

  function isMobile() {
    return window.matchMedia && window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
  }

  function getCartDrawerEl() {
    // Dawn uses <cart-drawer> custom element when drawer is enabled
    return document.querySelector("cart-drawer");
  }

  function openDrawer() {
    const drawer = getCartDrawerEl();
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return true;
    }

    // Fallback: simulate clicking the cart icon (works on many Dawn versions)
    const cartIcon =
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href^="/cart"]');

    if (cartIcon) {
      cartIcon.click();
      return true;
    }

    return false;
  }

  function closeDrawer() {
    const drawer = getCartDrawerEl();
    if (drawer && typeof drawer.close === "function") {
      drawer.close();
      return true;
    }

    // Fallback: click the overlay if present
    const overlay =
      document.querySelector(".drawer__overlay") ||
      document.querySelector(".cart-drawer__overlay");

    if (overlay) {
      overlay.click();
      return true;
    }

    // Fallback: click close button if present
    const closeBtn =
      document.querySelector("cart-drawer .drawer__close") ||
      document.querySelector("cart-drawer button[aria-label='Close']") ||
      document.querySelector("cart-drawer button[type='button']");

    if (closeBtn) {
      closeBtn.click();
      return true;
    }

    return false;
  }

  function scheduleMobileDrawerAutoClose() {
    if (!isMobile()) return;

    // Clear any previous timer (so repeated adds reset the countdown)
    if (drawerCloseTimer) {
      clearTimeout(drawerCloseTimer);
      drawerCloseTimer = null;
    }

    // If user interacts with the drawer, don't auto-close
    const drawer = getCartDrawerEl();
    if (drawer) {
      const cancelAutoClose = () => {
        if (drawerCloseTimer) {
          clearTimeout(drawerCloseTimer);
          drawerCloseTimer = null;
        }
        drawer.removeEventListener("pointerdown", cancelAutoClose);
        drawer.removeEventListener("touchstart", cancelAutoClose);
        drawer.removeEventListener("keydown", cancelAutoClose);
      };

      drawer.addEventListener("pointerdown", cancelAutoClose, { passive: true });
      drawer.addEventListener("touchstart", cancelAutoClose, { passive: true });
      drawer.addEventListener("keydown", cancelAutoClose);
    }

    drawerCloseTimer = setTimeout(() => {
      closeDrawer();
      drawerCloseTimer = null;
    }, DRAWER_AUTO_CLOSE_MS);
  }

  function isCartAddRequest(input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const method = (init && init.method) ? init.method.toUpperCase() : "GET";
    return method === "POST" && (url.includes("/cart/add") || url.includes("/cart/add.js"));
  }

  async function tryParseJson(response) {
    try {
      return await response.clone().json();
    } catch (e) {
      return null;
    }
  }

  function getHandleFromLocation() {
    const match = window.location.pathname.match(/\/products\/([^\/]+)/);
    return match && match[1] ? match[1] : "";
  }

  window.fetch = async function (input, init) {
    const isAdd = isCartAddRequest(input, init);

    const response = await originalFetch.apply(this, arguments);

    if (!isAdd || !response || !response.ok) return response;

    const data = await tryParseJson(response);
    if (!data) return response;

    const handle = (data && data.handle) ? String(data.handle) : getHandleFromLocation();
    const message = TOAST_BY_HANDLE[handle];

    // Toast only when product matches your list
    if (message && window.StockupToast && typeof window.StockupToast.showToast === "function") {
      window.StockupToast.showToast(message, { duration: 4000 });
    }

    // Mobile: open drawer then auto-close after 3 seconds
    if (isMobile()) {
      // Give Dawn a beat to render/update cart drawer contents
      setTimeout(() => {
        const opened = openDrawer();
        if (opened) scheduleMobileDrawerAutoClose();
      }, 150);
    }

    return response;
  };
})();
